<template>
    <section class="wrap_select">
			<div class="select_head">
				<h1>{{param.label || '선택'}}</h1>
			</div>
			<div class="selcet_body">
				<div class="select_option">
					<ul>
						<li :key="data" v-for="data in param.list" @click="$emit('select', data)"><button type="button" class="btn_slt"><span>{{data[param.name || 'name']}}</span></button></li>
					</ul>
				</div>
			</div>
			<button type="button" class="btn_icon btn_close_select" @click="$emit('close')"><i class="ico">닫기</i></button>
		</section>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: {}
    }
  },
  mounted(){
    console.log(this.param)
  }
}
</script>